import {Component, inject, model} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {FinanceDashboardChartPresentationType} from "../../enum/FinanceDashboardChartType";

interface IInsightQueriesModalData {
  labels: string[];
  amount: number[];
  percentage: number[];
}

@Component({
  selector: 'app-insight-queries-modal',
  templateUrl: './insight-queries-modal.component.html',
  standalone: false,
})
export class InsightQueriesModalComponent {
  private readonly dialogRef = inject(MatDialogRef<InsightQueriesModalComponent>);

  public readonly data = model.required<IInsightQueriesModalData>();

  public readonly presentationType = model.required<FinanceDashboardChartPresentationType>();

  protected close() {
    this.dialogRef.close();
  }

}
